import apiClient from './apiClient';

export const lotteryService = {
  getConfig: () => apiClient.get('/lottery/config').then((res) => res.data),
  getActivePeriod: () =>
    apiClient.get('/lottery/period/active').then((res) => res.data),
  getPrizes: () => apiClient.get('/lottery/prizes').then((res) => res.data),
  getPools: () => apiClient.get('/lottery/pools').then((res) => res.data),
  getDrawHistory: (limit) =>
    apiClient
      .get('/lottery/draws', { params: limit ? { limit } : undefined })
      .then((res) => res.data),
  getFeaturedNumbers: () =>
    apiClient.get('/lottery/featured-numbers').then((res) => res.data),
  getPaymentMethods: () =>
    apiClient.get('/lottery/payment-methods').then((res) => res.data),
  getTopUpPresets: () =>
    apiClient.get('/lottery/top-up-presets').then((res) => res.data),
};
